<template>
  <div style="padding-top:1px" class="input-box__container" :class="{ borderless: borderless }">
    <v-row no-gutters class="form-group">
      <span v-if="label !== ''" class="item-label">{{ label }}</span>
      <span v-else class="item-label" style="color:white" />
      <label class="form-group-label">
        <span v-if="required" class="mandatory">必須</span>
      </label>
      <div style="margin-top: 2px;margin-left: 4px;" column v-if="!switchless">
        <!-- クリック時に内部状態を更新し、親にも通知するメソッドを呼び出す -->
        <!-- internalManualInput → effectiveManualInput に変更 -->
        <v-chip class="inputTypeChip" small label pill dense dark :outlined="!effectiveManualInput" color="#4e9fc7" @click="setInputMode(true)" :tabindex="-1">手入力</v-chip>
        <v-chip class="inputTypeChip" small label pill dense dark :outlined="effectiveManualInput" color="#4e9fc7" @click="setInputMode(false)" :tabindex="-1">マスタ参照</v-chip>
      </div>
    </v-row>

    <!-- v-ifの条件を effectiveManualInput に変更 -->
    <component
      v-if="effectiveManualInput"
      :is="inputComponent"
      v-bind="computedPropsText"
      v-on="computedListeners"
      v-model="innerBindText"
      label=""
      solo
      flat
      auto-grow
      rows="1"
      :placeholder="phManualtext"
      :tabindex="readonly ? -1 : 0"
      append-icon=""
    />
    <template v-else>
      <div class="textarea-wrapper d-flex align-center" style="flex:1;">
        <v-textarea
          v-if="multiline && readonly"
          :value="displayText"
          auto-grow
          flat
          solo
          hide-details
          readonly
          rows="1"
        />
        <v-autocomplete
          v-else
          v-bind="computedProps"
          v-on="computedListeners"
          v-model="innerBindId"
          label=""
          solo
          flat
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0"
          :append-icon="readonly ? '' : 'mdi-menu-down'"
          :search-input.sync="autocompleteText">
          <template v-slot:append>
            <v-btn
              icon
              color="#83bde5"
              dark
              elevation="0"
              small
              v-if="!readonly"
              tabindex=-1
              @mousedown.prevent.stop=""
              @mouseup.prevent.stop=""
              @click.prevent.stop="onDialogButtonClick">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-autocomplete>
      </div>
    </template>

    <dd-master-search-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerList="headerList"
      :itemList="itemList"
      :targetMaster="targetMaster"
      :abbreviatedDisplay="abbreviatedDisplay"
      :itemsPerPage="itemsPerPage"
      @close="onDialogClosed"
    />
  </div>
</template>

<script>
import DdMasterSearchDialog from '@/components/DdMasterSearchDialog'

import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VAutocomplete, VTextarea } from 'vuetify/lib'

export default {
  name: 'DdCodeTextBoxSwitch',
  extends: VAutocomplete,
  mixins: [inputMixin],
  props: {
    /**
     * 手入力モードかどうか（親が.syncで制御する場合はこちらを利用）
     */
    manualInput: {
      type: Boolean,
      default: undefined
    },
    /*
     * ID
     */
    bindId: Number,
    /**
     * テキスト
     */
    bindText: String,
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: {
      type: Number,
      default: 999
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 返却値カラム名
     */
    returnValueName: {
      type: String,
      default: ''
    },
    /**
     *
     */
    code: String,
    /**
     * Dialog用ヘッダリスト
     * @see VDataTable
     */
    headerList: Array,
    /**
     * Dialog表示タイトル
     */
    titleText: String,
    /**
    * 絞り込み対象カラム
    */
    searchColumns: Array,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * 太枠
     */
    emphasis: {
      type: Boolean,
      default: false
    },
    /**
     * コード無しテキストのみ
     */
    isNotShowValue: {
      type: Boolean,
      default: false
    },
    /**
     * 枠線なし
     */
    borderless: {
      type: Boolean,
      default: false
    },
    /**
     * フォーカス時のみ値を表示する
     */
    revealOnFocus: {
      type: Boolean,
      default: false
    },
    /**
     * 切り替えボタン非表示
     */
    switchless: {
      type: Boolean,
      default: false
    },
    /**
     * multiline が true のときは v-textarea を使う
     */
    multiline: {
      type: Boolean,
      default: false
    },
    /**
     * 初期表示時に手入力モードを有効にする
     */
    defaultInputManual: {
      type: Boolean,
      default: true
    },
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 100
    }
  },
  components: {
    DdMasterSearchDialog,
    VTextarea
  },
  // ★ data はアロー関数にしない。this で props にアクセスして初期値を確定させる
  data () {
    return {
      hasFocus: true,
      showDialog: false,
      invalidMessage: '',
      autocompleteText: null,
      targetMaster: '',
      // internalManualInput → フォールバック変数に改名
      // ★ 初期表示は props の defaultInputManual をそのまま採用
      internalManualInputFallback: this.defaultInputManual,
      // ★ ユーザーが切替操作したかを記録（初期追従ロック用）
      userTouched: false,
      revealMode: false
    }
  },
  mounted () {
    console.log('DdCodeTextBoxSwitch.mounted', this.itemList, this.lazyValue)
    this.innerBindId = this.lazyValue
    this.invalidMessage = this.errorMessages
    // create targetMaster
    this.targetMaster = this.itemValue.replace('Cd', '')
  },
  watch: {
    itemList: function (newlist, oldlist) {
      this.itemList = newlist
    },
    // ★ 親の defaultInputManual が後から決まる／変わるケースをカバー
    //    ただし、ユーザーが一度でも切り替えたら以降は上書きしない
    defaultInputManual: {
      immediate: true,
      handler (val) {
        if (this.manualInput === undefined && !this.userTouched) {
          this.internalManualInputFallback = val
        }
      }
    }
  },
  computed: {
    /**
     * 有効な入力モードを一元管理
     * 親が manualInput を渡していればそれを最優先、
     * そうでなければ常にフォールバックを使う（切替が効くように）。
     */
    effectiveManualInput () {
      if (this.manualInput !== undefined) return this.manualInput
      return this.internalManualInputFallback
    },
    inputComponent () {
      // multiline === true なら v-textarea、そうでなければ v-text-field
      return this.multiline ? 'v-textarea' : 'v-text-field'
    },
    phtext () {
      return !this.readonly ? 'コードまたは名称で検索' : ' '
    },
    innerBindId: {
      get () {
        return this.bindId
      },
      set (value) {
        this.$emit('update:bindId', value)
      }
    },
    innerBindText: {
      get () {
        return this.bindText
      },
      set (value) {
        this.$emit('update:bindText', value)
      }
    },
    inputTypeDetail () {
      return controls.getInputTypeDetail(controls.InputTypes.Free)
    },
    phManualtext () {
      return this.length && !this.readonly ? this.inputTypeDetail.placeholder.replace('@@length@@', this.length) : ' '
    },
    computedPropsText () {
      return {
        ...this.$props,
        value: this.innerBindText,
        maxlength: this.length,
        class: this.$props.class + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : '') + (this.emphasis ? ' emphasis-item' : ''),
        type: this.inputType,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        class: this.$props.class + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : '') + (this.emphasis ? ' emphasis-item' : ''),
        hideDetails: 'auto',
        items: this.filteredItems,
        itemValue: this.itemValueName,
        itemText: 'text',
        clearable: false,
        clearIcon: '',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        filter: this.suggestFillter
      }
    },
    itemValueName () {
      return this.returnValueName === '' ? this.itemValue : this.returnValueName
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e),
        focusout: e => this.onFocusout(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    },
    filteredItems () {
      if (this.itemList === undefined) { return [] }
      return this.itemList.map(e => {
        const result = {
          ...e,
          value: e[this.itemValueName],
          text: this.isNotShowValue ? `${e[this.itemText]}` : this.revealOnFocus && !this.revealMode ? `${e[this.itemText]}` : `${e[this.itemValue]} : ${e[this.itemText]}`
        }
        return result
      })
    },
    displayText () {
      const sel = this.filteredItems.find(
        item => item.value === this.innerBindId
      )
      return sel ? sel.text : ''
    }
  },
  methods: {
    // 入力モードを切り替えるメソッド
    setInputMode (isManual) {
      this.userTouched = true // ★ 以降は defaultInputManual の変更で上書きしない
      if (this.manualInput !== undefined) {
        this.$emit('update:manualInput', isManual) // 親に通知して.syncを機能させる
      } else {
        this.internalManualInputFallback = isManual // 内部状態を更新
      }
    },
    onBlur: function (e) {
      console.log('DdCodeTextBoxSwitch.onBlur', e)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      console.log('DdCodeTextBox.onFocus', e)
      if (this.revealOnFocus) {
        this.revealMode = true
      }
    },
    onFocusout: function (e) {
      console.log('DdCodeTextBox.onFocusout', e)
      this.revealMode = false
    },
    onInput: function (e) {
      console.log('DdCodeTextBoxSwitch.onInput', e, e.target.value)
      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }

      const val = e.target.value
      if (val === '') {
        this.value = { value: '' }
      }
    },
    onDialogButtonClick: function (e) {
      this.showDialog = true
    },
    onDialogClosed: function (e) {
      this.showDialog = false
      if (e === undefined) { return }
      this.innerBindId = e[this.itemValueName]

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerBindId)
      this[controls.VALIDATE_METHOD]()
    },

    suggestFillter: function (item, queryText, itemText) {
      console.log('suggestFillter', item, queryText, itemText)
      const keys = !this.searchColumns ? Object.keys(item) : this.searchColumns
      for (let i = 0; i < keys.length; i++) {
        const v = String(item[keys[i]])
        if (v.indexOf(queryText) !== -1) { return true }
      }
      return false
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerBindId,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>

<style scoped>
.inputTypeChip {
  margin: 0 !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  height: 18px;
  width: 80px !important;
  justify-content: center;
}
</style>
